import React from 'react';

const Shiping = () => {
    return (
        <div>
          <h2>Shipping</h2>
          <p>Delivery On the way !!!! </p>
          <p><small>Comming Soon....</small></p>

        </div>
    );
};

export default Shiping;